import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { CollectionCommandsInterface } from '../../models/collection-public.port.models';
import { GetCollectionApi } from '../../state/actions/collection.actions';

@Injectable()
export class CollectionCommandsFacade implements CollectionCommandsInterface {
    constructor(private readonly store: Store) {}

    public getCollectionApi(slug: string, vip?: boolean): void {
        this.store.dispatch(GetCollectionApi({ slug, vip }));
    }
}
